import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const SidebarCameraIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 1.5 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      {/* Camera body */}
      <rect
        x="2"
        y="6"
        width="15"
        height="12"
        rx="2"
        stroke={color}
        strokeWidth={strokeWidth}
        fill="none"
      />
      {/* Lens */}
      <circle cx="9.5" cy="12" r="3" stroke={color} strokeWidth={strokeWidth} fill="none" />
      {/* Viewfinder / recording indicator */}
      <path
        d="M17 9l5-2v10l-5-2"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
        fill="none"
      />
    </BaseIcon>
  ),
);

SidebarCameraIcon.displayName = 'SidebarCameraIcon';
